import React, { useEffect } from 'react'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as DataProductActions from 'redux/actions/Applications/DataProducts'
import * as OntologyActions from 'redux/actions/Applications/Ontology'

import Alert from 'components/containers/Applications/Alert'
import SpecificAPI from 'components/containers/Applications/AccessHub/Specific'

const SpecificAPIPage = ({
  AppsDataProductStore,
  tryGetOneDataProduct,
  match,
  tryGetOntology,
  OntologyStore,
  history
}) => {
  useEffect(() => {
    tryGetOneDataProduct(match.params.id)

    if (!OntologyStore.fetched) {
      tryGetOntology()
    }
  }, [])

  useEffect(() => {
    const dp = AppsDataProductStore.data[AppsDataProductStore.currentFetchOne]

    if (dp && dp.attributes.type !== 'API') {
      history.push('/access-hub')
    }
  }, [AppsDataProductStore.currentFetchOne])

  const loaded =
    AppsDataProductStore.currentFetchOne === match.params.id &&
    OntologyStore.fetched

  return (
    <>
      {loaded ? <SpecificAPI /> : null}
      <Alert />
    </>
  )
}

function mapStateToProps({ AppsDataProductStore, AuthStore, OntologyStore }) {
  return { AppsDataProductStore, AuthStore, OntologyStore }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...DataProductActions,
      ...OntologyActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SpecificAPIPage))
